// src/pages/CustomerGallery.tsx
import React from "react";
import ResourcesSection from "../components/Resources/HeroSection";
import Title from "../components/typography/Title";
import JoinUs from "../components/JoinUs";

// OLD card strip (from blog/category)
import SanityBlogCards from "../blog/SanityBlogStrip";

// NEW strip (your customerCaseStudy schema)
import SanityCustomerGalleryStrip from "../blog/SanityCustomerGalleryStrip";
import Subtitle from "../components/typography/Subtitle";

export default function CustomerGallery() {
  return (
    <main className="flex w-screen flex-col px-4 py-5">
      {/* HERO section same as Resources */}
      <section className="flex h-auto w-screen flex-col items-center gap-4 p-8 sm:px-32 md:px-8 lg:px-32">
        <Subtitle>Customer Gallery</Subtitle>
        <Title>
          See what's coming next <br /> in AI-driven recruiting
        </Title>
      </section>
      <div className="mt-[50px] w-full px-2 md:px-6">
        <SanityCustomerGalleryStrip />
      </div>

      <JoinUs />
    </main>
  );
}
